import React, { useRef, useEffect, useState, PropsWithChildren } from "react";
import './CesiumViewer.scss';
import {Viewer, ImageryLayer, UrlTemplateImageryProvider, WebMercatorTilingScheme} from 'cesium';

export const CesiumViewerContext = React.createContext<Viewer | null>(
  null
);

interface Props {
  callback?: (viewer: Viewer) => void;
}

export default function CesiumViewer(props: PropsWithChildren<Props>) {
  const inputEl = useRef(document.createElement('div'));

  const [viewer, setViewer] = useState<Viewer | null>(null);

  useEffect(() => {
    
    const v = new Viewer(inputEl.current, {
      animation: false,
      homeButton: false,
      navigationHelpButton: false,
      infoBox: false,
      geocoder: false,
      baseLayerPicker: false,
      sceneModePicker: false,
      fullscreenButton: false,
      selectionIndicator: false,
      timeline: false,
      navigationInstructionsInitiallyVisible: false,
      baseLayer : new ImageryLayer(new UrlTemplateImageryProvider({
        url: 'https://services.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        tilingScheme: new WebMercatorTilingScheme(),
        maximumLevel: 18
      }), {})
    });
    var canvas = (v as any).canvas;
    (v as any).useBrowserRecommendedResolution = false;
    var resolutionScale = 1.0;
    resolutionScale = !isNaN(resolutionScale) ? resolutionScale : 1.0;
    (v as any).resolutionScale = resolutionScale;

    (v as any)._cesiumWidget._creditContainer.style.display = "none";
    (window as any).viewer = v;

    setViewer(v);
    if (props.callback) {
      props.callback(v);
    }
  }, []);

  return (
    <div className="CesiumViewer">
      <CesiumViewerContext.Provider value={viewer}>
        <div ref={inputEl} className="map"></div>
        {props.children}
      </CesiumViewerContext.Provider>
    </div>
  );
}
